<template>
  <div class="ManagementSKU">
    <div class="left">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText" style="width: 90%; margin-left: 5%; margin-bottom: 5px;">
      </el-input>
      <el-tree :data="Treedata" node-key="id" @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse" :props="defaultProps" :default-expanded-keys="defaultExpandIds" draggable
        :highlight-current="highlight" :allow-drop="allowDrop" @node-drop="sort" :expand-on-click-node="false"
        @node-click="handleNodeClick" ref="tree" :filter-node-method="filterNode">
        <span class="custom-tree-node" slot-scope="{ node, data }" @mouseover="mouseover(data)"
          @mouseleave="mouseleave(data)">
          <span>{{ data.categoryName }}</span>
          <span>
            <i class="el-icon-plus" v-show="data.plus" @click.stop="() => append(data)"></i>
            <i class="el-icon-minus" v-show="data.minus" @click.stop="() => remove(node, data)"></i>
            <i class="el-icon-edit" v-show="data.edit" @click.stop="() => editSublevel(data, node)"></i>
          </span>
        </span>
      </el-tree>
    </div>

    <div class="right">
      <div class="summary_complete_bag">
        <el-form :inline="true" label-width="114px" ref="selectForm" :model="selectForm">
          <el-form-item label="选择分部门">
            <el-select v-model="selectForm.departmentValue" placeholder="请选择" value-key="rid"
              @change="selectChange($event, 'groupList')">
              <el-option v-for="item in departmentList" :key="item.rid" :label="item.departmentName" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择组">
            <el-select v-model="selectForm.groupValue" placeholder="请选择" value-key="rid"
              @change="selectChange($event, 'staffList')">
              <el-option v-for="item in groupList" :key="item.rid" :label="item.groupName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择员工">
            <el-select v-model="selectForm.staffValue" placeholder="请选择" value-key="rid">
              <el-option v-for="item in staffList" :key="item.rid" :label="item.roleUserName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择销售类型">
            <el-select v-model="selectForm.salesType" placeholder="请选择">
              <el-option label="全部" :value="0"></el-option>
              <el-option label="普通销售" :value="1"></el-option>
              <el-option label="变参销售" :value="2"></el-option>
              <el-option label="捆绑销售" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品状态">
            <el-radio-group v-model="selectForm.resource">
              <template v-for="item in this.goodList">
                <el-radio :key="item.id" :label="item.id">{{
                  item.name
                }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="选择合并状态">
            <el-select v-model="selectForm.isMerge" placeholder="请选择">
              <el-option label="已合并" :value="2"></el-option>
              <el-option label="未合并" :value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="分类选项">
            <el-checkbox v-model="selectForm.isNullCategory">无分类选项</el-checkbox>
          </el-form-item>
          <el-form-item label="开始日期" prop="starttime">
            <el-date-picker v-model="selectForm.starttime" align="right" type="datetime" @change="startTime"
              placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期" prop="endtime">
            <el-date-picker v-model="selectForm.endtime" align="right" type="datetime" @change="endTime"
              placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label=" ">
            <el-input v-model.trim="selectForm.input" style="width:430px;" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getShopifyProduct">搜索</el-button>
            <el-button type="primary" @click="searchReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 符合查询条件的产品共-->
      <div class="summary_pagenum">
        <div class="summary_query">
          <el-button type="primary" @click="edit">新建SKU</el-button>
          <el-button type="primary" @click="moveCatry">批量移动分类</el-button>
          <!-- <el-button type="primary" @click="mergeSKU">合并SKU</el-button>
          <el-button type="primary" @click="CancelMerger">撤销合并</el-button> -->
        </div>
      </div>
      <div class="summary_content">
        <div class="summary_list">
          <!-- 头部 -->
          <el-table :data="summarylist" style="width: 100%" element-loading-text="拼命加载中" v-loading="loading" border
            :header-cell-style="iscenter" @selection-change="on_batch_select" stripe height="516">
            <el-table-column width="50" type="selection" align="center"></el-table-column>
            <el-table-column width="200" label="SKU/SKU别名" align="center">
              <template slot-scope="scope">
                <div>
                  <p><strong style="color:#000">主SKU：</strong>{{ scope.row.skuPrex + scope.row.productCode }}</p>
                  <!-- <p v-show="scope.row.salesType==2"><strong style="color:#000">变体SKU：</strong>{{ scope.row.variantSku }}</p> -->
                  <el-popover placement="right" width="400" trigger="click" @show="showSkuTable(scope.row)">
                    <el-table border max-height="200" :data="SKUtable" :span-method="spanMethod"
                      v-loading="showSkuTableLoading">
                      <el-table-column prop="variantSku" label="变体" v-if="scope.row.salesType == 2"></el-table-column>
                      <el-table-column prop="alias" label="别名"></el-table-column>
                    </el-table>
                    <el-button slot="reference" type="primary" size="small">查看SKU别名</el-button>
                  </el-popover>
                  <!-- <div v-for="(item, index) in scope.row.relatedItems" :key="index">
                    <div v-for="(key, index) in item.aliasItems" :key="index">
                      <p v-if="key.productCodeAlias">SKU别名：{{ key.productCodeAlias }}</p>
                    </div>
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column width="140" label="关联图片" align="center">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" :src="scope.row.productImage" fit="fill"
                  :preview-src-list="scope.row.productImages"></el-image>
              </template>
            </el-table-column>
            <el-table-column width="150" label="商品名称/变体名称" align="center">
              <template slot-scope="scope">
                <div style="display:flex;justify-content: center;">
                  <div style="margin-right:20px"><strong style="color:#000">产品名称：</strong> {{ scope.row.title }}</div>
                  <!-- <el-popover placement="right" width="420" trigger="hover">
                    <el-table :data="gridData" border>
                      <el-table-column align="center" property="date" label="SKU"></el-table-column>
                      <el-table-column align="center" property="name" label="3日销量"></el-table-column>
                      <el-table-column align="center" property="address" label="7日销量"></el-table-column>
                      <el-table-column align="center" property="address" label="15日销量"></el-table-column>
                      <el-table-column align="center" property="address" label="30日销量"></el-table-column>
                    </el-table>
                    <div slot="reference">
                      <i class="el-icon-s-data"></i>
                    </div>
                  </el-popover> -->
                </div>
                <!-- <p v-show="scope.row.salesType==2"><strong style="color:#000">变体名称：</strong>{{ scope.row.productVariantMarker }}</p> -->
              </template>
            </el-table-column>
            <el-table-column width="100" label="产品来源" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start" width="200" trigger="hover">
                  <div v-for="(item, index) in scope.row.sourceUrl" :key="index">
                    <el-link type="primary" :href="item.url" target="_blank">{{ item.url }}</el-link>
                  </div>
                  <el-button slot="reference" type="text" style="border:none">访问</el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="销售类型" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.salesType == 1">普通销售</p>
                <p v-else-if="scope.row.salesType == 2">变参销售</p>
                <p v-else-if="scope.row.salesType == 3">捆绑销售</p>
                <p v-else>组合销售</p>
              </template>
            </el-table-column>
            <el-table-column label="所属分类" align="center" prop="categoryName" />
            <el-table-column label="创建者" align="center" prop="creator">
            </el-table-column>
            <el-table-column label="商品状态" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 1" style="color: green">在售</p>
                <p v-else-if="scope.row.status == 2" style="color: red">停售</p>
                <p v-else-if="scope.row.status == 3" style="color: #0f59a4;">试卖</p>
                <p v-else-if="scope.row.status == 4" style="color: orange">部分停售</p>
                <p v-else-if="scope.row.status == 5">清仓</p>
                <p v-else>部分清仓</p>
              </template>
            </el-table-column>
            <el-table-column prop="stockNum" label="库存数量" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            <el-table-column label="操作" fixed="right" :width="operateWidth" align="center">
              <template slot-scope="scope">
                <el-dropdown @command="handleCommand($event, scope.row)">
                  <span class="el-dropdown-link">
                    查看<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">编辑</el-dropdown-item>
                    <el-dropdown-item command="b">删除</el-dropdown-item>
                    <el-dropdown-item command="c">试卖</el-dropdown-item>
                    <el-dropdown-item command="d">清仓</el-dropdown-item>
                    <el-dropdown-item command="e">在售</el-dropdown-item>
                    <el-dropdown-item command="f">同步</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="summary_pagenum_block">
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
            @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="size"
            layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新建/编辑分类 -->
    <el-dialog :title="isEdit ? '编辑层级' : '创建层级'" :visible.sync="sublevelVisible" :append-to-body="true" width="40%">
      <el-form ref="ruleForm" :model="sublevelForm" :rules="sublevelRules" label-width="120px">
        <el-form-item label="名称" prop="categoryName">
          <el-input v-model.trim="sublevelForm.categoryName" autocomplete="off" placeholder="请输入名称" style="width:60%">
          </el-input>
        </el-form-item>
        <el-form-item label="父级">
          <el-input v-model.trim="sublevelForm.parentName" disabled style="width:60%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="sublevelVisible = false">取 消</el-button>
        <el-button type="primary" @click="sublevelSubmit('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 预览图片 -->
    <el-dialog :visible.sync="dialogVisibleSee" width="500px">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>

    <!-- 新建/编辑 -->
    <CreatedSKU ref="CreatedSKU" @fatherMethod="getShopifyProduct"></CreatedSKU>

    <!-- 合并 -->
    <MergeSKU ref="MergeSKU" @fatherMethod="getShopifyProduct"></MergeSKU>

    <el-dialog title="移动分类" :visible.sync="dialogVisible" width="width">
      <div>
        <el-cascader-panel class="custom-cascader" :options="Treedata1" :props="props" emitPath="true"
          v-model="cascaderValue" @change="cascaderChange">
        </el-cascader-panel>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitOuterForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CreatedSKU from './createdSKU.vue'
import MergeSKU from './MergeSKU.vue'
import draggable from "vuedraggable";
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api'

export default {
  name: 'ManagementSKU',
  components: {
    CreatedSKU,
    draggable,
    MergeSKU
  },
  data() {
    return {
      defaultExpandIds: [],
      highlight: true,
      piece: 0,
      batch_select: [],
      batch_select2: [],
      gridData: [],
      isEdit: false,
      sublevelVisible: false,
      str: '',
      companyId: '',
      departmentList: [],
      groupList: [],
      staffList: [],
      sublevelForm: {
        categoryName: "",
        parentName: "",
        id: "",
        parentId: ""
      },
      dialogVisibleSee: false,
      dialogImageUrl: '',
      staffId: '',
      type: 1,
      currentPage: 1,
      size: 10,
      count: 1,
      operateWidth: 100,
      iscenter: {
        textAlign: 'center',
        background: '#f8f8f8',
        color: '#232323',
      },
      selectForm: {
        salesType: '',
        resource: 0,
        departmentValue: '',
        groupValue: '',
        starttime: '',
        endtime: '',
        input: '',
        staffValue: '',
        isMerge: '',
        isNullCategory: false
      },
      summarylist: [],
      goodList: [{
        id: 0, name: '全部'
      }, {
        id: 1, name: '在售'
      }, {
        id: 2, name: '停售'
      }, {
        id: 3, name: '试卖'
      }, {
        id: 4, name: '部分停售'
      }, {
        id: 5, name: '清仓'
      }, {
        id: 6, name: '部分清仓'
      }],
      Treedata: [],
      Treedata1: [],
      defaultProps: {
        children: "children",
        label: "categoryName"
      },
      sublevelRules: {
        categoryName: [
          {
            required: true,
            message: "请填写子级名称",
            trigger: "blur"
          }
        ]
      },
      SKUtable: [],
      showSkuTableLoading: false,
      dialogVisible: false,
      isLastChildNode: true,
      categoryId: '',
      props: {
        value: 'id',//设置每个menu的ID值
        label: 'categoryName',//设置每个menu的name值
        children: 'children',//子级
      },
      cascaderValue: [],
      loading: false,
      filterText: ''
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.staffId = this.str.rid
    this.init()
    this.getTreedata()
    this.getShopifyProduct()
  },
  watch: {
    dialogVisible(val) {
      if (!val) this.cascaderValue = []
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    moveCatry() {
      if (!this.batch_select.length) {
        this.$message.error('请至少勾选一件产品！')
        return
      }
      this.dialogVisible = true
    },
    submitOuterForm() {
      if (this.isLastChildNode) {
        this.$message.error("只能选择第四级分类！")
        return
      }
      const API = Baseurl + 'systemProduct/updateProductCategory'
      const paramsData = {
        categoryId: this.categoryId,
        productIds: this.batch_select
      }
      ajaxPost(API, paramsData)
        .then((res) => {
          if (res.data.code === 1) {
            this.$message({
              type: 'success',
              message: '移动成功!'
            });
            this.dialogVisible = false
            this.getShopifyProduct()
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    cascaderChange() {
      if (this.cascaderValue.length < 3) {
        this.isLastChildNode = true
      } else {
        this.isLastChildNode = false
      }
      this.categoryId = this.cascaderValue.slice(-1)[0]
    },
    showSkuTable(row) {
      const API = Baseurl + 'systemProduct/getAlias?productId=' + row.id
      this.showSkuTableLoading = true
      ajaxGet(API)
        .then((res) => {
          this.SKUtable = []
          res.data.data.variantAlias.map(item => {
            if (item.aliasDetailVO && item.aliasDetailVO.length) {
              item.aliasDetailVO.map(ele => {
                let obj = JSON.parse(JSON.stringify(item))
                this.$set(obj, 'alias', ele.alias)
                this.SKUtable.push(obj)
              })
            } else {
              this.SKUtable.push(item)
            }
          })
          this.showSkuTableLoading = false
          this.spanMethod()
        })
    },
    spanMethod(data) {
      if (!data) return
      const num = data.row.aliasDetailVO.length === 0 ? 1 : data.row.aliasDetailVO.length
      const arr = [0]
      if (arr.includes(data.columnIndex)) {
        if (
          data.rowIndex > 0 &&
          data.row.id === this.SKUtable[data.rowIndex - 1].id
        ) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          return {
            rowspan: num,
            colspan: 1
          }
        }
      }
    },
    on_batch_select(val) {
      var newarr = [];
      this.piece = val.length;
      for (var i = 0; i < val.length; i++) {
        newarr.push(val[i].id);
      }
      this.batch_select = newarr;
      this.batch_select2 = val;
    },
    mergeSKU() {
      const result = this.batch_select2.every(item => {
        return item.salesType === this.batch_select2[0].salesType
      })
      if (this.piece <= 1) {
        this.$message.warning('请至少勾选两件产品！')
        return;
      } else if (!result) {
        this.$message.warning('请选择相同销售类型的产品')
      } else {
        this.$refs.MergeSKU.init(this.batch_select2)
      }
    },
    handleCommand(val, row) {
      if (val === 'a') {
        this.$refs.CreatedSKU.init(row)
      } else if (val === 'b') {
        let msg = '此操作将永久删除此商品, 是否继续?'
        if (row.salesType !== 3) {
          msg = '此操作将永久删除此产品,如果有捆绑产品捆绑了该产品会影响到捆绑产品,是否确定删除?'
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const API = Baseurl + 'systemProduct/delete/' + row.id
            ajaxGet(API)
              .then((res) => {
                if (res.data.code === 1) {
                  this.$message.success('删除成功')
                  this.getShopifyProduct()
                } else {
                  this.$message.error(res.data.message)
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除"
                });
              });
          })
      } else if (val === 'c') {
        this.updateStatus(3, row.id)
      } else if (val === 'd') {
        this.updateStatus(5, row.id)
      } else if (val === 'e') {
        this.updateStatus(1, row.id)
      } else if (val === 'f') {
        this.$confirm("确定同步该产品系统sku吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loading = true
            const API = Baseurl + 'systemProduct/syncSystemSku'
            ajaxPost(API, { productId: row.id })
              .then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('同步成功')
                  this.getShopifyProduct()
                } else {
                  this.$message.error(res.data.message)
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消同步"
                });
              });
          })
      }
    },
    updateStatus(status, id) {
      this.$confirm("确定更改商品状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const API = Baseurl + 'systemProduct/updateStatus?id=' + id + '&status=' + status
          ajaxPost(API)
            .then((res) => {
              if (res.data.code === 1) {
                this.$message.success('修改状态成功');
                this.getShopifyProduct()
              } else {
                this.$message.error(res.data.message)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消更改"
          });
        });
    },
    searchReset() {
      this.selectForm.departmentValue = ''
      this.selectForm.groupValue = ''
      this.selectForm.staffValue = ''
      this.selectForm.salesType = ''
      this.selectForm.resource = 0
      this.selectForm.starttime = ''
      this.selectForm.endtime = ''
      this.selectForm.input = ''
      this.selectForm.isMerge = ''
      this.selectForm.isNullCategory = false
      this.staffId = this.str.rid
      this.currentPage = 1
      this.size = 10
      this.highlight = false
      this.getShopifyProduct()
    },
    init() {
      const {
        rid,
        system,
        company_id: companyId,
        type: companyType,
        superDepartmentName,
      } = this.str
      this.companyId = companyId
      this.staffId = rid
      let type = ''
      if (companyType === 1) {
        type = 'branchCompany'
        if (
          superDepartmentName === '客服部' ||
          superDepartmentName === '常规客服部'
        ) {
          type = 'sonCompany'
        }
      } else if (companyType === 2) {
        type = 'sonCompany'
      } else if (system < 3) {
        type = 'departmentList'
      } else if (system === 3) {
        type = 'groupList'
      } else if (system === 4) {
        type = 'staffList'
      } else {
        return
      }
      this.getNextPower(rid, system, type)
    },
    getNextPower(rid, system, type) {
      const API = Baseurl + 'roleController/selectNextInfoByRid'
      const paramsData = { rid, system, companyId: this.companyId, sellerType: 2 }
      ajaxPost(API, paramsData)
        .then((res) => {
          const {
            data: { code, data },
          } = res
          if (code === 200) {
            this[type] = data.next
          }
        })
    },
    selectChange(event, type) {
      const { rid, system, company_id: companyId } = event
      companyId && (this.companyId = companyId)
      this.getNextPower(rid, system, type)
      if (type === 'sonCompany') {
        this.selectForm.sonCompany = {}
        this.selectForm.departmentValue = {}
        this.selectForm.groupValue = {}
        this.sonCompany = []
        this.departmentList = []
        this.groupList = []
      } else if (type === 'departmentList') {
        this.selectForm.departmentValue = {}
        this.selectForm.groupValue = {}
        this.departmentList = []
        this.groupList = []
      } else if (type === 'groupList') {
        this.selectForm.groupValue = {}
        this.groupList = []
      }
      this.selectForm.staffValue = {}
      this.staffList = []
      this.staffId = rid
    },
    getShopifyProduct(categoryId = '') {
      if (typeof (categoryId) == 'object') {
        categoryId = ''
      }
      const API = Baseurl + 'systemProduct/page'
      const paramsData = {
        page: this.currentPage,
        size: this.size,
        title: this.selectForm.input,
        roleId: this.staffId,
        salesType: this.selectForm.salesType,
        status: this.selectForm.resource,
        startTime: this.selectForm.starttime,
        endTime: this.selectForm.endtime,
        isMerge: this.selectForm.isMerge,
        isNullCategory: this.selectForm.isNullCategory,
        categoryId
      }
      this.loading = true
      ajaxPost(API, paramsData)
        .then((res) => {
          if (res.data.code === 1) {
            this.summarylist = res.data.data.records
            this.summarylist.forEach(val => {
              const source = val.sourceUrl.split(',')
              val.productImages = val.productImages.split(',')
              if (val.productImages.length) val.productImage = val.productImages[0]
              val.sourceUrl = source.map((item) => ({
                url: item
              }))
            })
            this.count = res.data.data.total
          } else {
            this.$message.error(res.data.message)
          }
          this.loading = false
        })
    },
    mouseover(data) {
      if (data.menuType == 0) {
        this.$set(data, 'plus', true)
        this.$set(data, 'minus', false)
        this.$set(data, 'edit', false)
      } else if (data.menuType == 3) {
        this.$set(data, 'plus', false)
        this.$set(data, 'minus', true)
        this.$set(data, 'edit', true)
      } else if (data.menuType == 1 || data.menuType == 2) {
        this.$set(data, 'plus', true)
        this.$set(data, 'minus', true)
        this.$set(data, 'edit', true)
      }
    },
    mouseleave(data) {
      this.$set(data, 'plus', false)
      this.$set(data, 'minus', false)
      this.$set(data, 'edit', false)
    },
    sublevelSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isEdit) {
            const API = Baseurl + 'systemCategory/update'
            const paramsData = {
              id: this.sublevelForm.id,
              parentId: this.sublevelForm.parentId,
              categoryName: this.sublevelForm.categoryName,
              companyId: this.companyId
            }
            ajaxPost(API, paramsData)
              .then((res) => {
                if (res.data.code === 1) {
                  this.$message({
                    type: "success",
                    message: "编辑成功!"
                  });
                  this.sublevelVisible = false
                  this.getTreedata()
                  this.getShopifyProduct()
                } else {
                  this.$message.error(res.data.message)
                }
              })
          } else {
            const API = Baseurl + 'systemCategory/create'
            const paramsData = {
              parentId: this.sublevelForm.id,
              categoryName: this.sublevelForm.categoryName,
              companyId: this.companyId
            }
            ajaxPost(API, paramsData)
              .then((res) => {
                if (res.data.code === 1) {
                  this.$message({
                    type: "success",
                    message: "添加成功!"
                  });
                  this.sublevelVisible = false
                  this.getTreedata()
                } else {
                  this.$message.error(res.data.message)
                }
              })
          }
        } else {
          this.$message.error("请填写必填项");
          return false;
        }
      })
    },
    append(data) {
      this.isEdit = false;
      this.sublevelVisible = true
      if (data) {
        this.sublevelForm = {
          parentName: data.categoryName,
          categoryName: "",
          id: data.id,
          parentId: data.parentId
        }
      } else {
        this.sublevelForm = {
          parentName: 0,
          categoryName: "",
          id: "",
          parentId: ""
        }
      }
    },
    editSublevel(data, node) {
      this.isEdit = true;
      this.sublevelVisible = true
      this.sublevelForm.categoryName = data.categoryName
      this.sublevelForm.id = data.id
      this.sublevelForm.parentName = node.parent.data.categoryName
      this.sublevelForm.parentId = data.parentId
    },
    remove(_, data) {
      this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const API = Baseurl + 'systemCategory/delete/' + data.id
          ajaxGet(API)
            .then((res) => {
              if (res.data.code === 1) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getTreedata()
                this.getShopifyProduct()
              } else {
                this.$message.error(res.data.message)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    getTreedata() {
      const API = Baseurl + 'systemCategory/find?companyId=' + this.str.company.id
      ajaxGet(API)
        .then((res) => {
          if (res.data.code === 1) {
            this.$set(this.Treedata, 0, { categoryName: '分类列表', children: [], menuType: 0, id: '0' })
            res.data.data.forEach(item => {
              this.$set(item, 'menuType', 1)
              if (item.children) {
                item.children.forEach(val => {
                  this.$set(val, 'menuType', 2)
                  if (val.children) {
                    val.children.forEach(key => {
                      this.$set(key, 'menuType', 3)
                    })
                  }
                })
              }
            })
            this.Treedata[0].children = res.data.data
            this.Treedata1 = JSON.parse(JSON.stringify(this.Treedata[0].children))
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    allowDrop(draggingNode, dropNode, type) {
      //pid是父节点id
      if (draggingNode.data.parentId === dropNode.data.parentId) {
        return type === "prev" || type === "next";
      } else {
        // 不同级进行处理
        return false;
      }
    },
    sort(_, dropNode) {
      let obj = {
        params: []
      }
      for (let item of dropNode.parent.childNodes) {
        obj.params.push(item.data);
      }
      this.updateOrderMe(obj)
    },
    updateOrderMe(params) {
      const API = Baseurl + 'systemCategory/updateSort'
      ajaxPost(API, params)
        .then((res) => {
          if (res.data.code === 1) {
            // this.getTreedata()
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    CancelMerger() {
      if (this.piece === 0) {
        this.$message.warning('请至少勾选一件产品！')
        return;
      } else if (this.piece >= 2) {
        this.$message.warning('只能选择一条合并产品进行撤销！')
        return;
      } else if (this.batch_select2[0].isMerge === 1) {
        this.$message.warning('请选择合并产品进行撤销!')
        return;
      } else {
        this.$confirm('确定要把已合并的SKU数据撤销恢复原数据状态吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const API = Baseurl + 'shopifyProduct/undoMerge/' + this.batch_select2[0].id
          ajaxGet(API)
            .then((res) => {
              if (res.data.code === 1) {
                this.$message({
                  type: 'success',
                  message: '撤销成功!'
                });
                this.getShopifyProduct()
              } else {
                this.$message.error(res.data.message)
              }
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销'
          });
        })
      }
    },
    edit() {
      this.$refs.CreatedSKU.init()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getShopifyProduct()
    },
    handleSizeChange(val) {
      this.size = val
      this.getShopifyProduct()
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) { // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      // 删除当前关闭的节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1)
        }
      })
      this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
    },
    // 删除树子节点
    removeChildrenIds(data) {
      const ts = this
      if (data.children) {
        data.children.forEach(function (item) {
          const index = ts.defaultExpandIds.indexOf(item.id)
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1)
          }
          ts.removeChildrenIds(item)
        })
      }
    },
    handleNodeClick(val) {
      this.highlight = true
      this.getShopifyProduct(val.id)
    },
    complete(index) {
      this.type = index
    },
    //选择开始时间
    startTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 00:00:00'
      this.selectForm.starttime = datetime
    },
    // 选择结束时间
    endTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 23:59:59'
      this.selectForm.endtime = datetime
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.categoryName.indexOf(value) !== -1;
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #ccc !important;
}

/deep/ .el-tree-node__content:hover {
  background: #eee !important;
}

.ManagementSKU {
  width: 98%;
  display: flex;
  // padding-bottom: 100px;
  justify-content: space-between;
  height: 100%;

  .block {
    margin-bottom: 20px;
  }

  .left {
    width: 15%;
    float: left;
    border: 1px solid #eee;
    padding: 10px 0;
    border-radius: 4px;
    height: calc(100% - 80px);
    overflow-y: auto;

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;

      .el-icon-minus {
        margin: 0 8px;
      }
    }
  }

  .right {
    width: 83%;

    .el-icon-s-data {
      cursor: pointer;
    }

    .summary_complete_bag {
      overflow: hidden;

      .summary_complete {
        overflow: hidden;
        padding: 10px 0;
        border-bottom: 1px #eee solid;

        div {
          padding: 0 10px;
          height: 30px;
          border: #2c8dff 1px solid;
          line-height: 30px;
          text-align: center;
          color: #2c8dff;
          float: left;
          border-radius: 4px;
          cursor: pointer;
        }

        .active {
          background: #2c8dff;
          color: #fff;
        }
      }
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #409EFF;
    }

    .el-icon-arrow-down {
      font-size: 12px;
    }
  }

  .summary_pagenum {
    width: 100%;
    margin-bottom: 10px;
    overflow: hidden;
    background: #f5f5f5;

    .summary_query {
      padding: 5px 10px;
    }
  }

  .summary_pagenum_block {
    width: 1789px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }

  /deep/ .el-dialog__header {
    background: rgb(236, 236, 236);
    border-radius: 2px 2px 0 0;
  }
}
</style>
